import { css } from "@digits-css"
import colors from "@digits-shared/themes/colors"
import { GRADIENT_HALO_BACKGROUND } from "@digits-shared/themes/gradientHaloBackground"
import "./gradientHalo.digits.css"

export const GRADIENT_HALO = css`
  background-color: ${colors.glowBackground};
  background: ${GRADIENT_HALO_BACKGROUND};
  --module-loading-color: ${colors.white};
  &::before {
    content: "";
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    z-index: -1;
    backdrop-filter: blur(72px);
  }
`
